<script>
import { fade , scale } from 'svelte/transition';
import {link , push} from 'svelte-spa-router'
import fetchData from '../api.js';
import { _ } from "svelte-i18n";
import { onMount } from 'svelte';
import  ProductsPopup from '../components/products.svelte';
import Preloader from '../components/Preloader.svelte';
import VariantSelector from '../components/VariantSelector.svelte';

let isLoading = false;


let order_id = '#7557';
let phone_number = '0546265461';
let error = '';
let completed = false;
let payment_link = '';

let order = {};
let items = [];
let replacedItems = {};
let returnType = {};
let returnReason = {};
let returnNames = {}
let popupActive = false;
let comparedPrice = 0;
let currency = '';
let selectedItem = '';


const handleSubmit = async () => {

    console.log('ajax_object',ajax_object)

    if (typeof ajax_object.ajax_url==='undefined' && typeof ajax_object.ajaxurl!=='undefined') {
        ajax_object.ajax_url =  ajax_object.ajaxurl
    }

    isLoading = true;

    let formData = {
        order_id ,
        phone_number,
        url : ajax_object.ajax_url,
        action : 'order_lookup',
        security: ajax_object.order_lookup_nonce,
        token : ajax_object.token || ''
    }       

    const data = await fetchData(formData);
    if (data.success==1) {


        order = data.data;
        if (typeof order.qty == "undefined") {
            order.qty = 0
        }

        if (order.error) {

            error = order.error;

        } else {


            data.data.items = data.data.items.filter((item)=> {

                order.qty += item.quantity

                returnNames[item.id] = item.name
                replacedItems[item.id] = item.product;

                if (item.subtotal<=0) {
                    return false;
                }
                return item;

            })
            items = data.data.items;
            currency = order.currency;

            error = '';

        }

        
        

    } else {
        error = data.data;
    }

    isLoading = false;

}

const openReplace = async (item_id) => {
    if (!replacedItems[item_id]){
        alert('יש לבחור אפשרות להחלפה');
    } else {

        let formData = {
            order_id ,
            phone_number,
            item_id: item_id,
            new_product_id: replacedItems[item_id],
            url : ajax_object.ajax_url,
            action : 'process_replace',
            security: ajax_object.process_replace_nonce,
            token : ajax_object.token || ''
        }       

        const data = await fetchData(formData);
        if (data.success==1) {

            if (data.data.message) {

                if (data.data.payment_link) {

                    error = data.data.payment_link

                } else {
                    error = data.data.message
                }
            } else {
                error = data.data
            }

        } else {

            error = data.data

        } 

    }

    
}

const setReturn = async () => {

    

    let formData = {
        order_id ,
        phone_number,
        item_id: item_id,
        url : ajax_object.ajax_url,
        action : 'process_return',
        security: ajax_object.process_return_nonce,
        token : ajax_object.token || ''
    }       

    const data = await fetchData(formData);
    if (data.success==1) {

        error = data.data;

    } else {

        error = data.data;

    } 
}

const completeReturnProcess = async ()=> {

    if (!Object.keys(returnType).length) {
        return;
    }

    let returnItems = []

    //console.log(returnType,replacedItems);return;

    for(var item_id in returnType) {

        let item = {};


        item.reason = returnReason[item_id]
        item.name = returnNames[item_id];

        if (returnType[item_id]=='return') {

            item.type = "return";
            item.item_id = item_id;            
            returnItems.push(item);

        } else {

            item.type = "replace";
            item.item_id = item_id;
            item.new_item_id = replacedItems[item_id].id;
            item.new_variant_id = replacedItems[item_id].new_variant_id || '';
            item.new_variant_name = replacedItems[item_id].name || '';
            returnItems.push(item);
            
        }

    }

    let formData = {
        order_id ,
        phone_number,
        items: JSON.stringify(returnItems),
        url : ajax_object.ajax_url,
        action : 'complete_process_returns',
        security: ajax_object.process_replace_nonce,
        token : ajax_object.token || ''
    }       

    const data = await fetchData(formData);
    if (data.success) {


        completed = true;
        error = '';

        //if (data.data.message) {

            if (data.data.payment_link) {

                payment_link = data.data.payment_link

            } else if (data.data.success) {
                    
            }
                
            

       // }

    } else {

        error = data.data

    } 
    

}

const selectProduct = (e) =>{

    let product = e.detail
    console.log('selected product',product);

    popupActive = false;

    replacedItems[selectedItem] = product;

    console.log('replacedItems',replacedItems)
    
}

const closePopup = () => {
    popupActive = false;
}
    
</script>


<ProductsPopup {popupActive} {comparedPrice} {currency} on:selectProduct={selectProduct} on:closePopup={closePopup}></ProductsPopup>
<div class="page dashboard" transition:fade={{ delay: 250, duration: 300 }}>
    <div>
        <h1 class="dash-title">{$_('dashboard.welcome')}</h1>
        <h2 class="dash-title">{@html $_('dashboard.welcome_paragraph')}</h2>
        <form id="dash-form" on:submit|preventDefault={handleSubmit}>
            <div><lable>{$_('dashboard.order_id')}</lable><input type="text" placeholder="{$_('dashboard.order_id')}" required bind:value={order_id}></div>
            <div><lable>{$_('dashboard.phone_number')}</lable><input type="text" placeholder="{$_('dashboard.phone_number')}" required bind:value={phone_number}></div>            
            <div><button type="submit" class="login-button">{$_('dashboard.search_button')}</button></div>
        </form>
        <div class:error={error!==''} in:scale>{error}</div>
        <Preloader {isLoading}></Preloader>  
        {#if completed}
        <div class="returns-complete">
            <div class="success_icon"><i class="fa-solid fa-circle-check"></i></div>
            <div class="success_text">{$_('dashboard.completed')}</div>
            {#if payment_link}
            <div class="payment_link_text">{$_('dashboard.completed_payment')}</div>
            <div class="payment_link_url"><a href="{payment_link}">{$_('dashboard.pay_now')}</a></div>
            {/if}
        </div>
        {/if}      
        {#if items.length && !completed}
        <div class="returns-order">
            <div class="returns-items-orderinfo">
                <div class="title">{$_('dashboard.order_name')}: {order.order_name}</div>   
                <div>{$_('dashboard.qty')}: {order.qty}</div>
                <div>{$_('dashboard.date')}: {order.date}</div>
            </div>
            <div class="returns-items-container">
                <div class="returns-items-head">{$_('dashboard.items_list')}</div>
                <div class="returns-items-table">
                    {#each items as item}
                        <div class="returns-items-row">
                            <div class="returns-items-col">
                                <!-- <div>
                                    <label class="styled-checkbox">
                                        <input type="checkbox" on:click={!item.checked} bind:checked={item.checked}>
                                        <span class="checkbox-label">
                                            <i class="fa-solid fa-check"></i>
                                        </span>
                                    </label>                                
                                </div> -->                                
                                <div class="returns-items-col-content">
                                    <div class="returns-items-col-content-box">
                                        <div><img src="{item.image}"></div>
                                        <div>
                                            <div><strong>{item.name}</strong></div>
                                            <div class="">                                    
                                                <div>{$_('dashboard.total')}: {item.subtotal} {order.currency}</div>
                                                <div>{$_('dashboard.qty')}: {item.quantity}</div>
                                            </div>
                                            <div class="returns-desc">{item.desc}</div> 
                                            {#if returnType[item.id]=='replace_with_other'}
                                            <div class="refunds_choose_product">
                                                <div class="returns-radio" on:click={()=> { comparedPrice = parseFloat(item.subtotal); popupActive = true; selectedItem = item.id }}> <i class="fa-solid fa-magnifying-glass"></i> {$_('dashboard.search_product_button')}</div>
                                            </div>
                                            {/if} 
                                        </div>
                                    </div>  
                                    {#if ['replace_with_same','replace_with_other'].indexOf(returnType[item.id])!==-1 && replacedItems[item.id]} 
                                    <div class="returns-items-col-content-box-title">
                                        <div><i class="fa-solid fa-chevron-down"></i></div>
                                        <div>{$_('dashboard.replaced_item_title')}:</div>                       
                                    </div>                                    
                                    <div class="returns-items-col-content-box">                                        
                                        <div><img src="{replacedItems[item.id].image}"></div>
                                        <div>                                            
                                            <div><strong>{replacedItems[item.id].name}</strong></div>
                                            <div class="">                                    
                                                {#if returnType[item.id]=='replace_with_same'}
                                                    <div class="compare_notice">{$_('dashboard.no_difference_payment')}</div>
                                                {:else}
                                                    <div>{replacedItems[item.id].price}{currency}</div>           
                                                    {#if item.subtotal < replacedItems[item.id].price}
                                                    <div class="compare_notice">{#if item.subtotal < replacedItems[item.id].price} {$_('popup.difference_payment')} { replacedItems[item.id].price - item.subtotal }{currency} {/if}</div>
                                                    {/if}
                                                {/if}
                                            </div>
                                            <div class="returns-variant">
                                                {#if replacedItems[item.id].type=='variable'}
                                                    {#if (replacedItems[item.id].variant_options && replacedItems[item.id].variant_options.length) || (replacedItems[item.id].variants && replacedItems[item.id].variants.length) }
                                                        
                                                        <VariantSelector replacedItem={replacedItems[item.id]} bind:value={replacedItems[item.id].new_variant_id}/>
                                                        <!--
                                                        <select bind:value={replacedItems[item.id].new_variant_id}>
                                                            <option value="">{$_('dashboard.choose_option')}</option>
                                                            {#if replacedItems[item.id].variant_options}
                                                                {#each replacedItems[item.id].variant_options as variant}
                                                                    {#each Object.keys(variant.attributes) as variant_key}
                                                                    <option value="{variant.variant_id}">{decodeURIComponent(variant.attributes[variant_key])}</option>
                                                                    {/each}
                                                                {/each}
                                                            {/if}
                                                            {#if replacedItems[item.id].variants}
                                                                {#each replacedItems[item.id].variants as variant}
                                                                <option value="{variant.variant_id}">
                                                                    {#each Object.keys(variant.product_options) as option_key}
                                                                        {decodeURIComponent(variant.product_options[option_key].name + ' ' + variant.product_options[option_key].value) + ' '}                                                                         
                                                                    {/each}
                                                                </option>
                                                                {/each}
                                                            {/if}
                                                        </select>
                                                        -->
                                                    {:else}
                                                        <div class="returns-notice">{$_('dashboard.no_available_product_options')}</div>
                                                    {/if}
                                                {:else}
                                                    {#if replacedItems[item.id].avail_quantity <= 0}
                                                        <div class="returns-notice">{$_('dashboard.no_available_product')}</div>
                                                    {/if}
                                                {/if}
                                            </div>  
                                        </div>                                        
                                    </div> 
                                    {/if}                    
                                </div>
                                <div class="returns-items-col-buttons">
                                    <div class="returns-types">
                                        <!--<div class="returns-radio" class:selected={returnType[item.id]=='replace_with_other'} on:click={()=>{ if (returnType[item.id] && returnType[item.id]=='replace_with_other') { returnType[item.id] = false; } else { returnType[item.id] = 'replace_with_other'; replacedItems[item.id] = false} }}> <i class="fa-solid fa-arrow-right-arrow-left"></i> {$_('dashboard.replace_with_other')}</div>-->
                                        <div class="returns-radio" class:selected={returnType[item.id]=='replace_with_same'} on:click={()=>{ if (returnType[item.id] && returnType[item.id]=='replace_with_same') { returnType[item.id] = false; } else { returnType[item.id] = 'replace_with_same'; if (item.product.length) { replacedItems[item.id] = item.product[0] } else { replacedItems[item.id] = item }} }}> <i class="fa-solid fa-arrow-right-arrow-left"></i> {$_('dashboard.replace_with_same')}</div>
                                        <div class="returns-radio" class:selected={returnType[item.id]=='return'} on:click={()=>{ if (returnType[item.id] && returnType[item.id]=='return') { returnType[item.id] = false; } else { returnType[item.id] = 'return'} }}> <i class="fa-solid fa-rotate-left"></i> {$_('dashboard.return')}</div>
                                    </div>
                                    {#if returnType[item.id]} 
                                    <div class="refunds-reason-title">{$_('refunds.reason.title')}</div>
                                    <div class="refunds-reasons">
                                        <label class="returns-radio-input"><input type="radio" value="{$_('refunds.reason.accidental_order')}" bind:group={returnReason[item.id]}> {$_('refunds.reason.accidental_order')} <div></div></label>
                                        <label class="returns-radio-input"><input type="radio" value="{$_('refunds.reason.quality')}" bind:group={returnReason[item.id]}> {$_('refunds.reason.quality')} <div></div></label>
                                        <label class="returns-radio-input"><input type="radio" value="{$_('refunds.reason.damaged')}" bind:group={returnReason[item.id]}> {$_('refunds.reason.damaged')} <div></div></label>
                                        <label class="returns-radio-input"><input type="radio" value="{$_('refunds.reason.shipping')}" bind:group={returnReason[item.id]}> {$_('refunds.reason.shipping')} <div></div></label>
                                        <label class="returns-radio-input"><input type="radio" value="{$_('refunds.reason.wrong_item')}" bind:group={returnReason[item.id]}> {$_('refunds.reason.wrong_item')} <div></div></label>
                                        <label class="returns-radio-input"><input type="radio" value="{$_('refunds.reason.unauthorized')}" bind:group={returnReason[item.id]}> {$_('refunds.reason.unauthorized')} <div></div></label>
                                        <label class="returns-radio-input"><input type="radio" value="{$_('refunds.reason.other')}" bind:group={returnReason[item.id]}> {$_('refunds.reason.other')} <div></div></label>
                                    </div>                                        
                                    {/if}
                                </div>
                            </div>                            
                        </div>
                    {/each}
                </div>                       
            </div>
            <div class="overview">
                <h2>{$_('dashboard.overview_title')}</h2>
                {#each items as item}                
                    {#if ['replace_with_same','replace_with_other','return'].indexOf(returnType[item.id])!==-1 && replacedItems[item.id]} 
                        <div class="overview-box">
                            {$_('dashboard.request')}
                            {#if returnType[item.id]=='return'}
                            <u>{$_('dashboard.return')}</u>
                            {/if}
                            {#if ['replace_with_same','replace_with_other'].indexOf(returnType[item.id])!==-1}
                            <u>{$_('dashboard.replace')}</u>
                            {/if}
                            <strong>{item.name}</strong>
                            {#if ['replace_with_same','replace_with_other'].indexOf(returnType[item.id])!==-1}
                                <u>{$_('dashboard.with')}</u>
                                <strong>{replacedItems[item.id].name}</strong>
                                {#if replacedItems[item.id].type=='variable'}
                                    {#if (replacedItems[item.id].variant_options && replacedItems[item.id].variant_options.length) || (replacedItems[item.id].variants && replacedItems[item.id].variants.length) }                                        
                                        {#if replacedItems[item.id].variants}
                                           {#each replacedItems[item.id].variants as variant}
                                                {#if variant.variant_id==replacedItems[item.id].new_variant_id}
                                                    {#each Object.keys(variant.product_options) as option_key}
                                                        {decodeURIComponent(variant.product_options[option_key].name + ' ' + variant.product_options[option_key].value) + ' '}                                                                         
                                                    {/each}
                                                {/if}
                                            {/each}
                                        {/if}
                                    {:else}
                                        <span class="returns-notice">{$_('dashboard.no_available_product_options')}</span>
                                    {/if}
                                {:else}
                                {/if}
                            {/if}
                        </div>
                    {/if}
                {/each}
            </div>          
            <div class="returns-bottom-actions">                
                <div class="returns-button" class:disabled={!Object.keys(returnType).length} on:click={()=> completeReturnProcess()}><i class="fa-solid fa-circle-check"></i> {$_('dashboard.finish_button')} </div>
            </div>
        </div>
        {/if}

        {#if items.length}
        <h2>תנאים לביצוע החזרה</h2>
        <ul>
            <li>
                <p>יש לבצע את ההחזרה במסגרת התקופה שנקבעה:</p>
                <p>רכישה און ליין: יש לכם ארבעה עשר ימים מרגע קבלת ההזמנה כדי לבצע החזרה. ההחזר הכספי יתבצע לאותו אמצעי תשלום שבו השתמשתם לביצוע הרכישה. אם תבצעו החזרה בין 15 ל-30 יום לאחר קבלת ההזמנה, תקבלו שובר זיכוי. אם ברצונכם להחזיר פריט מוזל, עומדים לרשותכם 14 ימים ממועד קבלת הזמנתכם. ההחזר הכספי יתבצע לאותו אמצעי תשלום שבו השתמשתם לביצוע הרכישה.</p>
                <p>רכישה בחנות פיזית: יש לכם 30 ימים מיום הרכישה כדי להחזיר את הקנייה שלכם. זכרו שיש להציג את קבלת הרכישה. במהלך עונת המבצעים/מבצעים מיוחדים, ניתן להחזיר מוצרים תוך 5 ימים מתאריך הרכישה.</p>
                <p>שימו לב כי ההחזר הכספי יתקבל בהתאם לתקנות הגנת הצרכן (ביטול עסקה) התשע"א 2010.</p>
            </li>
            <li>על הפריטים להיות במצבם המקורי ועם כל התוויות</li>
            <li>יש לבצע את ההחזרה באותו שוק/אזור שבו בוצעה הרכישה.</li>
        </ul>
        <p>תוכלו למצוא מידע נוסף על מדיניות ההחלפות וההחזרות או על הזכות לביטול עסקה ב- תנאי הרכישה.</p>

        <h2>איסוף מהבית</h2>
        <ul>
            <li>
        <p>קיימת אפשרות להחזיר את הפריטים באמצעות שירות איסוף מהבית. עלות בקשת ההחזרה היא 30 ₪ שיופחתו מסכום ההחזר הכספי.</p>
            </li>
            <li>
        <p>לאחר ביצוע בקשת ההחזרה, השליח יאסוף את החבילה מכל כתובת שתבחרו תוך 24-48 שעות.</p>
            </li>
            <li>
        <p>אין צורך להדפיס אף תווית ההחזרה, השליח כבר יגיע איתה.</p>
            </li>
            <li>
        <p>קחו בחשבון שאפשרות זו זמינה רק עבור רכישה און ליין.</p>
            </li>
            <li>
        <p>זכרו לצרף את חשבונית הקנייה. </p>
            </li>
        </ul>
        {/if}
    </div>
</div>